/**
 * Main popup (.main-popup-wrap): Swiper, close button, "오늘 하루 그만 보기" cookie.
 * 레이아웃에서 Swiper 로드. 전역에서 init (app.ts runGlobalInits).
 */

declare global {
    interface Window {
        Swiper?: new (selector: string, options: Record<string, unknown>) => { params: Record<string, unknown>; update: () => void };
    }
}

function getSlidesPerView(popupCount: number): number {
    const width = window.innerWidth;
    if (width >= 1200) return popupCount >= 3 ? 3 : popupCount;
    if (width >= 768) return popupCount >= 2 ? 2 : popupCount;
    return 1;
}

export function initMainPopup(): void {
    const wrap = document.querySelector(".main-popup-wrap");
    if (!wrap) return;

    const popupCount = parseInt(wrap.getAttribute("data-popup-index") ?? "1", 10);
    const Swiper = typeof window !== "undefined" ? window.Swiper : undefined;
    if (!Swiper) return;

    const mainPopup = new Swiper(".main-popup-slide", {
        pagination: { el: ".swiper-pagination", clickable: true },
        navigation: {
            nextEl: "[data-index=\"next\"]",
            prevEl: "[data-index=\"prev\"]",
        },
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: getSlidesPerView(popupCount),
    });

    window.addEventListener("resize", () => {
        mainPopup.params.slidesPerView = getSlidesPerView(popupCount);
        mainPopup.update();
    });

    const closeButton = document.querySelector(".popup-close");
    const mainPopupEl = document.querySelector<HTMLElement>(".main-popup-wrap");
    const checkbox = document.getElementById("closeCheck") as HTMLInputElement | null;
    const popupImage = document.getElementById("popupImage") as HTMLElement | null;
    const popupImageOn = document.getElementById("popupImage-on") as HTMLElement | null;

    if (closeButton && mainPopupEl) {
        closeButton.addEventListener("click", () => {
            mainPopupEl.style.display = "none";
            if (checkbox?.checked) {
                const expires = new Date();
                expires.setHours(23, 59, 59, 999);
                document.cookie = `popupClosed=true; expires=${expires.toUTCString()}; path=/`;
            }
        });
    }

    if (checkbox && popupImage && popupImageOn) {
        checkbox.addEventListener("change", () => {
            const isChecked = checkbox.checked;
            popupImage.style.display = isChecked ? "none" : "inline";
            popupImageOn.style.display = isChecked ? "inline" : "none";
        });
    }
}
